// extracted by mini-css-extract-plugin
export var adjacentSlide = "_oz-9";
export var arrowButtonContainer = "_oz-5";
export var arrowButtonIcon = "_oz-6";
export var carouselArrowButton = "_oz-2";
export var carouselElementContainer = "_oz-1";
export var currentSlide = "_oz-8";
export var left = "_oz-3";
export var otherSlide = "_oz-a";
export var productCarouselContainer = "_oz-0";
export var right = "_oz-4";
export var sliderOverflow = "_oz-7";